import { useState } from 'react';
import { NavLink ,useNavigate} from "react-router-dom";
import { LayoutDashboard, Users, FileText, Settings, Sun, Moon, User, LogOut, ChevronUp, Headphones, MessageSquareDot } from "lucide-react";
import { useAuthContext } from '../../Auth/AuthContext';
import useAuthService from '../../../services/AuthService';
import '../../LandingPages/MainLandingPage.css'



const menuItems = [
  // { path: "/admin", label: "Dashboard", icon: LayoutDashboard },
  { path: "/admin/students", label: "Students", icon: Users },
{ path: "/admin/feedback", label: "Students Feedback", icon: MessageSquareDot },
  // { path: "/admin/assessments", label: "Assessments", icon: FileText },
];

function Sidebar() {
  const { portalTheme, setPortalTheme,onLogout  } = useAuthContext();
  const authService = useAuthService();
  const navigate = useNavigate();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);


  const toggleTheme = () => {
    const newTheme = portalTheme === 'light' ? 'dark' : 'light';
    setPortalTheme(newTheme);
    localStorage.setItem('portalTheme', newTheme);
    document.documentElement.setAttribute('theme', newTheme);
  };

  const handleSupportClick = () => {
    const supportEmail = "support@botguru.ai";
    const subject = encodeURIComponent("Support Request");
    const body = encodeURIComponent("Hello, I need help with...");
    const gmailURL = `https://mail.google.com/mail/?view=cm&fs=1&to=${supportEmail}&su=${subject}&body=${body}`;
    const mailtoURL = `mailto:${supportEmail}?subject=${subject}&body=${body}`;
    const newWindow = window.open(gmailURL, "_blank");
    if (!newWindow || newWindow.closed || typeof newWindow.closed === "undefined") {
        window.location.href = mailtoURL;
    }
};

  const handleLogout = async () => {
    try {
      const response = await authService.logout({ credentials: 'include' });
      if (response && response.isAuthenticated === false) {
        localStorage.removeItem("userObjId");
        localStorage.removeItem("userRole");
        localStorage.removeItem("userEmail")
        onLogout();
        navigate("/");
      }
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };
  
  return (
    <aside
      className="w-64 flex flex-col h-full"
      style={{
        background:
          "linear-gradient(180deg, var(--navigation-bar-color), var(--buttons-background-color))",
        boxShadow:
          "rgba(0, 0, 0, 0.2) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
      }}
    >
      {/* Logo */}
      <div className="p-2">
      <img className='logo' 
                        src={portalTheme === "light" ? "/botGuruBlackLogo.svg" : "/botgurulogo.png"} 
                       
                        style={{ pointerEvents: 'none' }}>
      </img>
      </div>


      

      {/* Profile */}
      <div className="px-4 mb-6">
        <div className="flex items-center gap-2 text-text-main">
          <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
            <User size={25} />
          </div>
          
          <div className="flex-1">
            <p className="font-semibold text-lg text-text-main">Admin User</p>
            {/* <p className="text-xs text-text-main opacity-70">University</p> */}
          </div>
        </div>
      </div>

      <div className="px-4 mb-2 flex items-center justify-between">
  <div className="flex items-center gap-2 text-text-main text-sm">
    {portalTheme === 'light' ? <Moon size={16} /> : <Sun size={16} />}
    <span>{portalTheme === 'light' ? 'Dark Mode' : 'Light Mode'}</span>
  </div>
  <div className="toggle-theme-container">
    <input
      type="checkbox"
      id="sidebar-checkbox"
      checked={portalTheme === 'light'}
      onChange={toggleTheme}
    />
    <label htmlFor="sidebar-checkbox" className="toggle-theme-label">
      <span className="toggleBtn"></span>
      <Sun className="sun-icon" />
      <Moon className="moon-icon" />
    </label>
  </div>
</div>


      {/* Nav */}
      <nav className="flex-1 px-4">
        <ul className="space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;

            return (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  end={item.path === "/admin"}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 rounded-lg transition-colors relative border border-purple-glow-30 text-text-main no-underline ${
                      isActive ? "font-semibold bg-white/15" : "hover:bg-white/5"
                    }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <div className="absolute right-0 top-0 bottom-0 w-1 rounded-l-lg bg-text-main" />
                      )}

                      <Icon size={20} />
                      <span>{item.label}</span>
                    </>
                  )}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Account */}
      {/* <div className="p-4 border-t border-white/20 space-y-1">
        <NavLink
          to="/admin/account"
          className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-white/5 transition-colors text-text-main no-underline"
        >
          <Settings size={20} />
          <span>Account</span>
        </NavLink>

        <button
          onClick={() => setShowLogoutConfirm(true)}
          className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-red-500/10 transition-colors text-red-400 w-full"
        >
          <LogOut size={20} />
          <span>Logout</span>
        </button>
      </div> */}

<div className="p-4 border-t border-white/20 relative">
    <button
        onClick={() => setShowProfileMenu((prev) => !prev)}
        className="flex items-center justify-center bg-primary gap-3 px-4 py-3 rounded-lg hover:bg-white/10 transition-colors text-text-main w-full"
    >
        <Settings size={20} />
        <span className="flex-1 text-left">Account</span>
        <ChevronUp
            size={16}
            className="transition-transform duration-200"
            style={{ transform: showProfileMenu ? 'rotate(0deg)' : 'rotate(180deg)' }}
        />
    </button>

    {showProfileMenu && (
        <>
            <div className="fixed inset-0 z-[90]" onClick={() => setShowProfileMenu(false)} />
            <div
                className="absolute bottom-16 left-2 right-2 z-[95] rounded-xl border border-white/20 overflow-hidden"
                style={{
                  background:
                    "linear-gradient(180deg, var(--navigation-bar-color), var(--buttons-background-color))",
                  boxShadow:
                    "rgba(0, 0, 0, 0.2) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
                }}
            >
                <NavLink
                    to="/admin/account"
                    onClick={() => setShowProfileMenu(false)}
                    className="flex items-center gap-3 px-4 py-3 hover:bg-white/10 transition-colors text-text-main no-underline "
                >
                    <User size={18} />
                    <span className="text-sm font-medium">My Account</span>
                </NavLink>

                <button
                    onClick={() => { setShowProfileMenu(false); handleSupportClick(); }}
                    className="flex items-center gap-3 px-4 py-3 hover:bg-white/10 transition-colors text-text-main w-full bg-transparent outline-none"
                >
                    <Headphones size={18} />
                    <span className="text-sm font-medium">Support</span>
                </button>

                <div className="border-t border-white/20" />

                <button
                    onClick={() => { setShowProfileMenu(false); setShowLogoutConfirm(true); }}
                    className="flex items-center gap-3 px-4 py-3 hover:bg-red-500/10 transition-colors text-red-400 w-full bg-transparent outline-none"
                >
                    <LogOut size={18} />
                    <span className="text-sm font-medium">Logout</span>
                </button>
            </div>
        </>
    )}
</div>
      {showLogoutConfirm && (
        <>
          <div className="fixed inset-0 bg-black/60 z-[100] backdrop-blur-sm" onClick={() => setShowLogoutConfirm(false)} />
          <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
            <div className="bg-screen-bg rounded-lg p-6 max-w-sm w-full border border-purple-glow-30 shadow-glow-lg" onClick={(e) => e.stopPropagation()}>
              <div className="flex items-center gap-3 mb-4">
                <LogOut size={24} className="text-red-500" />
                <h3 className="text-lg font-semibold text-text-main">Confirm Logout</h3>
              </div>
              <p className="text-text-sub mb-6">Are you sure you want to log out? You'll need to sign in again to access your account.</p>
              <div className="flex gap-3 justify-end">
                <button onClick={() => setShowLogoutConfirm(false)} className="px-4 py-2 rounded-lg border border-purple-glow-20 text-btn-text hover:bg-purple-700 cursor-pointer">Cancel</button>
                <button onClick={handleLogout} className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 cursor-pointer">Logout</button>
              </div>
            </div>
          </div>
        </>
      )}
    </aside>
    
  );
}

export default Sidebar;